import { Percent, DollarSign } from 'lucide-react';
import { cn } from '@/lib/utils';

export interface DiscountDisplayProps {
  discountType?: 'percentage' | 'fixed_amount';
  discountPercentage?: number;
  discountValue?: number;
  maxDiscountAmount?: number;
}

export function DiscountDisplay({
  discountType,
  discountPercentage,
  discountValue,
  maxDiscountAmount,
}: DiscountDisplayProps) {
  const effectiveType = discountType ?? 'percentage';

  if (effectiveType === 'percentage') {
    const percentageValue = discountPercentage !== undefined && discountPercentage !== null
      ? Number(discountPercentage)
      : undefined;
    const maxCapValue = maxDiscountAmount !== undefined && maxDiscountAmount !== null
      ? Number(maxDiscountAmount)
      : undefined;
    const hasValue = percentageValue !== undefined && percentageValue > 0;
    const hasMaxCap = maxCapValue !== undefined && maxCapValue > 0;

    return (
      <div className="flex items-center gap-3">
        <div
          className={cn(
            'flex h-10 w-10 shrink-0 items-center justify-center rounded-lg',
            'bg-primary/10 text-primary',
          )}
        >
          <Percent className="h-5 w-5" />
        </div>
        <div>
          <div className="font-medium">Percentage Off</div>
          <div className="text-sm text-muted-foreground">
            {hasValue ? (
              <>
                {percentageValue}% discount
                {hasMaxCap && <span className="ml-1">(up to ${maxCapValue.toFixed(2)})</span>}
              </>
            ) : (
              'No percentage set'
            )}
          </div>
        </div>
      </div>
    );
  }

  if (effectiveType === 'fixed_amount') {
    const amountValue = discountValue !== undefined && discountValue !== null
      ? Number(discountValue)
      : undefined;
    const hasValue = amountValue !== undefined && amountValue > 0;

    return (
      <div className="flex items-center gap-3">
        <div
          className={cn(
            'flex h-10 w-10 shrink-0 items-center justify-center rounded-lg',
            'bg-primary/10 text-primary',
          )}
        >
          <DollarSign className="h-5 w-5" />
        </div>
        <div>
          <div className="font-medium">Fixed Amount</div>
          <div className="text-sm text-muted-foreground">
            {hasValue ? `$${amountValue.toFixed(2)} off` : 'No amount set'}
          </div>
        </div>
      </div>
    );
  }

  return null;
}
